import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
  });

  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const API_BASE_URL = "https://breathwork-backend-brown.vercel.app";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccessMessage('Your message has been sent successfully! We will get back to you soon.');
        setFormData({ firstName: '', lastName: '', email: '', phone: '', message: '' });

        setTimeout(() => {
          setSuccessMessage(null);
        }, 5000);
      } else {
        setSuccessMessage('Error sending message. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSuccessMessage('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-lighttan px-8 py-16">
      <h1 className="mt-16 text-4xl font-bold text-center text-darkgreentext mb-16">
        Contact Us
      </h1>

      {successMessage && (
        <div className="max-w-lg mx-auto mb-6 p-4 bg-greenbutton text-lighttan text-lg border border-greenbutton rounded-md text-center shadow-md transition-opacity duration-500">
          {successMessage}
        </div>
      )}

      <form
        className="max-w-lg mx-auto bg-tantext p-8 rounded-lg shadow-lg"
        onSubmit={handleSubmit}
      >
        <div className="flex gap-4 mb-6">
          <div className="w-1/2">
            <label htmlFor="firstName" className="block text-darkgreentext font-bold mb-2">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full border-b border-darkgreentext focus:outline-none focus:ring-0 bg-transparent"
              required
            />
          </div>

          <div className="w-1/2">
            <label htmlFor="lastName" className="block text-darkgreentext font-bold mb-2">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full border-b border-darkgreentext focus:outline-none focus:ring-0 bg-transparent"
              required
            />
          </div>
        </div>

        <div className="mb-6">
          <label htmlFor="email" className="block text-darkgreentext font-bold mb-2">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border-b border-darkgreentext focus:outline-none focus:ring-0 bg-transparent"
            required
          />
        </div>

        <div className="mb-6">
          <label htmlFor="phone" className="block text-darkgreentext font-bold mb-2">
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border-b border-darkgreentext focus:outline-none focus:ring-0 bg-transparent"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="message" className="block text-darkgreentext font-bold mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full border-b border-darkgreentext focus:outline-none focus:ring-0 bg-transparent"
            rows={3}
            required
          />
        </div>

        <button
          type="submit"
          className="mx-auto block text-darkgreentext font-bold py-2 px-4 rounded hover:bg-lighttan transition"
        >
          Send Message
        </button>
      </form>
    </div>
  );
};

export default Contact;
